// extracted by mini-css-extract-plugin
export var siteHeader = "SiteHeader-module--siteHeader--I+Gl0";
export var logo = "SiteHeader-module--logo--sGGJO";
export var nav = "SiteHeader-module--nav--QDP0x";
export var hamburger = "SiteHeader-module--hamburger--P1yly";